import Decimal from 'decimal.js';

export function parseIncompleteFloatValue(value: string | null | undefined) {
  if (!value) {
    return '';
  }

  const lastDelimeterIndex = Math.max(value.lastIndexOf('.'), value.lastIndexOf(','));

  const replaced = value.replace(/\D/g, (_, index) => (index === lastDelimeterIndex ? '.' : ''));
  return replaced;
}

export function parseFloatValue(value: string | null | undefined) {
  const incomplete = parseIncompleteFloatValue(value);
  const parsed = Number.parseFloat(incomplete);

  return Number.isNaN(parsed) ? 0 : parsed;
}

export function formatPercentValue(value: Decimal.Value) {
  return new Decimal(value).mul(100).toString();
}

export function isPercentPositive(value: Decimal.Value | null | undefined): value is Decimal.Value {
  return value ? new Decimal(value).gt(0) : false;
}

export function parsePercentValue(value: string | null | undefined) {
  const floatValue = parseFloatValue(value);

  return new Decimal(floatValue).div(100).toNumber();
}
